import { assert } from 'assert-ts';

export function calculateBeforeAfter<T>(items: T[], { oldIndex, newIndex }: { oldIndex: number; newIndex: number }) {
  // We show tags reversed from what the API uses, so we have to calculate the move in terms of API order
  const reversedItems = [...items].reverse();
  const reversedOldIndex = items.length - 1 - oldIndex;
  const reversedNewIndex = items.length - 1 - newIndex;

  const moved = assert(reversedItems[reversedOldIndex], 'Could not find tag to reorder');
  let reference: T | undefined;
  let moveType: 'before' | 'after' = 'after';
  if (reversedNewIndex === 0) {
    moveType = 'before';
    reference = assert(reversedItems[0], 'Could not find previously-first tag');
  } else {
    reference = assert(
      reversedItems[reversedNewIndex < reversedOldIndex ? reversedNewIndex - 1 : reversedNewIndex],
      'Could not find tag to move after'
    );
  }

  return { moved, moveType, reference };
}
